import React, { useEffect } from 'react';
import StaticLandingPage from './components/StaticLandingPage';
import './App.css'; // Keeping the main app styles

function StaticApp() {
  useEffect(() => {
    // Apply the default theme
    document.documentElement.classList.add('theme-platform-admin');
  }, []);

  return (
    <div className="App">
      <StaticLandingPage />
    </div>
  );
}

export default StaticApp;
